import React from 'react';
import PropTypes from 'prop-types';
import { StyledPagingArrow } from './Carousel.styles';
import SVGIcon from '../../BuildingBlocks/SVGIcon/SVGIcon';
import { colors } from '../../css';

const directionObject = { left: 90, right: 270 };

/**
 * PagingDots overwrites the default components used in the pagination of the bottom controls of the Carousel.
 * If we need to change the icon or other functionality of the Carousel dots this is where we would do it.
 */
function PagingArrows(props) {
  const { onClick, arrowColor, direction } = props;

  const getDirection = () => directionObject[direction];

  return (
    <StyledPagingArrow direction={direction} onClick={onClick} className={`arrow-${direction}`}>
      <SVGIcon width="60px" selectedIcon="arrow" iconColor={arrowColor} rotate={getDirection()} />
    </StyledPagingArrow>
  );
}

PagingArrows.propTypes = {
  onClick: PropTypes.func.isRequired,
  arrowColor: PropTypes.string,
  direction: PropTypes.string
};

PagingArrows.defaultProps = {
  arrowColor: colors.colorBurgundy,
  direction: 'left'
};

export default PagingArrows;
